import { ECardStatus, ELogLevel, EUserStatus } from '@xeppt/xeppt-sdk/types';
import {
    ETransactionAction,
    ETransactionMethod,
    ETransactionStatus
} from '@xeppt/xeppt-sdk/types/transaction';
import { EConsumerStatus } from '@xeppt/xeppt-sdk/types/consumer';

export const paymentSystems = {
    visa: {
        name: 'VISA'
        // Icon: <VisaIcon />,
    },
    mastercard: {
        name: 'MasterCard'
        // Icon: <VisaIcon />,
    }
};

export const supportedLanguages = ['en', 'fr'];

export const userStatuses = [
    {
        label: 'Suspended',
        value: EUserStatus.SUSPENDED
    },
    {
        label: 'Active',
        value: EUserStatus.ACTIVE
    },
    {
        label: 'Pending',
        value: EUserStatus.PENDING
    },
    {
        label: 'Unverified',
        value: EUserStatus.UNVERIFIED
    },
    {
        label: 'Unconfirmed',
        value: EUserStatus.UNCONFIRMED
    },
    {
        label: 'Blocked',
        value: EUserStatus.BLOCKED
    }
];

export const userStatusesUpdates = [
    {
        label: 'Suspend',
        value: EConsumerStatus.SUSPENDED
    },
    {
        label: 'Block',
        value: EConsumerStatus.BLOCKED
    },
    {
        label: 'Activate',
        value: EConsumerStatus.ACTIVE
    }
];

export const cardStatusesUpdates = [
    {
        label: 'Temporarily Closed',
        value: ECardStatus.TEMPORARY_CLOSED
    },
    {
        label: 'Waiting for Activation',
        value: ECardStatus.WAITING_FOR_ACTIVATION
    },
    {
        label: 'Lost',
        value: ECardStatus.LOST
    },
    {
        label: 'Stolen',
        value: ECardStatus.STOLEN
    },
    {
        label: 'Other',
        value: ECardStatus.OTHER
    },
    {
        label: 'Fraud',
        value: ECardStatus.FRAUD
    },
    {
        label: 'Customer Request',
        value: ECardStatus.CUSTOMER_REQUEST
    },
    {
        label: 'Closed',
        value: ECardStatus.CLOSED
    },
    {
        label: 'Legal Closed',
        value: ECardStatus.LEGAL_CLOSED
    },
    {
        label: 'Freezed',
        value: ECardStatus.FREEZED
    }
];

export const errorCodes = [
    'INVALID_STRING_FORMAT',
    'MUST_BE_A_NUMBER',
    'INVALID_ISO_CODE',
    'INVALID_DATE_FORMAT',
    'INVALID_URL_FORMAT',
    'LENGTH',
    'MIN_LENGTH',
    'MAX_LENGTH',
    'EFT_ACCOUNT_EXISTS',
    'MUST_BE_EQUAL',
    'MUST_BE_ONE_OF',
    'INVALID_REQUEST',
    'NOT_FOUND',
    'USER_PHONE_EXIST',
    'USER_ALREADY_ACTIVATED',
    'AUTH_ERROR',
    'AUTH_INVALID_CREDENTIALS',
    'UNAUTHORIZED',
    'ACCESS_DENIED',
    'BANK_ACCOUNT_NOT_FOUND',
    'BANK_ACCOUNT_UPDATE_FAILED',
    'DEBIT_FUNDS_FAILED',
    'CREDIT_FUNDS_FAILED',
    'ACCOUNT_INSUFFICIENT_BALANCE',
    'FIND_EFT_ACCOUNT_ERROR',
    'LINK_EFT_ACCOUNT_ERROR',
    'EFT_ACCOUNT_EXISTS',
    'LINK_E_TRANSFER_ACCOUNT_ERROR',
    'E_TRANSFER_ACCOUNT_EXISTS',
    'UNSUPPORTED_METHOD',
    'FIND_E_TRANSFER_ACCOUNT_ERROR',
    'BILLING_PAYEE_NOT_FOUND',
    'BILLING_PAYEE_LIST_FAILED',
    'BILLING_PAYEE_CREATION_FAILED',
    'BILLING_PAYEE_UPDATE_FAILED',
    'BILLING_PAYMENT_NOT_FOUND',
    'BILLING_PAYMENT_LIST_FAILED',
    'BILLING_PAYMENT_CREATION_FAILED',
    'BILLING_PAYMENT_STATUS_UPDATE_FAILED',
    'BILLING_PAYMENT_UPDATE_FAILED',
    'CREATE_CONTACT_ERROR',
    'CONTACT_EXISTS',
    'CONTACT_NOT_FOUND',
    'DECODE_STRING_FAILED',
    'NEW_SESSION_FAILED',
    'PUT_OBJECT_FAILED',
    '(Processor)_CARD_NOT_FOUND',
    'DECODE_PEM_FAILED',
    'PARSE_DER_FAILED',
    'RSA_KEY_ERROR',
    'ENCRYPT_FAILED',
    'SET_PIN_FAILED',
    'CREATE_WALLET_FAILED',
    'CREATE_PHYSIC_CARD_FAILED',
    'GET_CARD_DETAILS_FAILED',
    'INSTITUTION_NOT_FOUND',
    'BRANCH_NOT_FOUND',
    'CUSTOMER_CREATE_FAILED',
    'CUSTOMER_UPDATE_FAILED',
    'COUNTRY_LIST_FAILED',
    'PROVINCE_LIST_FAILED',
    'CITY_LIST_FAILED',
    'CREATE_EFT_FAILED',
    'CREATE_E_TRANSFER_FAILED',
    'CREATE_SUPPLEMENTARY_CARD_FAILED',
    'CREATE_CONTACT_FAILED',
    'CARD_TRANSACTIONS_ERROR',
    'BILL_PAYMENT_FAILED',
    'TRANSACTION_CREATE_FAILED',
    'TRANSACTION_NOT_FOUND',
    'EFT_TRANSACTION_NOT_FOUND',
    'ETRANSFER_TRANSACTION_NOT_FOUND',
    'USER_NOT_FOUND',
    'USER_NOT_CREATED',
    'PHONE_NOT_FOUND',
    'EMAIL_NOT_FOUND',
    'EMAIL_EXISTS',
    'PHONE_EXISTS',
    'EMAIL_IS_PRIMARY',
    'PHONE_IS_PRIMARY',
    'PHONE_NOT_VERIFIED',
    'EMAIL_NOT_VERIFIED',
    'ADDRESS_NOT_FOUND',
    'INVALID_VERIFICATION_CODE',
    'USER_ALREADY_ACTIVATE',
    'INVALID_ACTIVATION_CODE',
    'INVALID_RESET_TOKEN',
    'USER_VERIFICATION_FAILED',
    'INVALID_PASSWORD',
    'USER_VERIFICATION_NOT_FOUND',
    'SETTINGS_NOT_FOUND',
    'WALLET_CARD_NOT_FOUND',
    'ACTIVATE_CARD_FAILED',
    'REPLACE_CARD_FAILED',
    'UPDATE_CARD_LIMIT_FAILED',
    'REQUEST_CARD_FAILED',
    'MAX_LIMIT_REACHED'
];

export const transactionsType = [
    { label: 'Payment', value: ETransactionAction.PAYMENT },
    { label: 'Withdraw', value: ETransactionAction.WITHDRAW },
    { label: 'Request', value: ETransactionAction.REQUEST },
    { label: 'Deposit', value: ETransactionAction.DEPOSIT },
    { label: 'Refund', value: ETransactionAction.REFUND },
    { label: 'Transfer', value: ETransactionAction.TRANSFER },
    { label: 'Card deposit', value: ETransactionAction.CARD_DEPOSIT },
    { label: 'Card service', value: ETransactionAction.CARD_SERVICE },
    { label: 'Cashback', value: ETransactionAction.CASHBACK },
    { label: 'Issue gift card', value: ETransactionAction.GIFT_CARD },
    { label: 'Redeem gift card', value: ETransactionAction.GIFT_CARD_REDEEM },
    { label: 'Reserve gift card funds', value: ETransactionAction.GIFT_CARD_RESERVE }
];

export const transactionsMethods = [
    { label: 'Bank', value: ETransactionMethod.EFT },
    { label: 'Wallet', value: ETransactionMethod.WALLET },
    { label: 'E-Transfer', value: ETransactionMethod.E_TRANSFER },
    { label: 'Bill Payment', value: ETransactionMethod.PAY_BILL },
    { label: 'Card', value: ETransactionMethod.EPS },
    { label: 'Gift card', value: ETransactionMethod.GIFT_CARD }
];

export const logsLevels = [
    { label: 'Info', value: ELogLevel.INFO },
    { label: 'Warnings', value: ELogLevel.WARNING },
    { label: 'Error', value: ELogLevel.ERROR }
];

export const transactionsStatuses = [
    { label: 'Approved', value: ETransactionStatus.APPROVED },
    { label: 'Canceled', value: ETransactionStatus.CANCELED },
    { label: 'Pending', value: ETransactionStatus.PENDING },
    { label: 'Error', value: ETransactionStatus.ERROR },
    { label: 'Declined', value: ETransactionStatus.DECLINED }
];

export const consumerStatuses = [
    {
        label: 'Suspend',
        value: EConsumerStatus.SUSPENDED
    },
    {
        label: 'Activate',
        value: EConsumerStatus.ACTIVE
    },
    {
        label: 'Pending',
        value: EConsumerStatus.PENDING
    },
    {
        label: 'Unverified',
        value: EConsumerStatus.UNVERIFIED
    },
    {
        label: 'Unconfirmed',
        value: EConsumerStatus.UNCONFIRMED
    },
    {
        label: 'Blocked',
        value: EConsumerStatus.BLOCKED
    }
];

export const cardStatuses = [
    {
        label: 'Active',
        value: ECardStatus.ACTIVE
    },
    {
        label: 'Unactivated',
        value: ECardStatus.TEMPORARY_CLOSED
    },
    {
        label: 'Waiting for activation',
        value: ECardStatus.WAITING_FOR_ACTIVATION
    },
    {
        label: 'Lost',
        value: ECardStatus.LOST
    },
    {
        label: 'Stolen',
        value: ECardStatus.STOLEN
    },
    {
        label: 'Other',
        value: ECardStatus.OTHER
    },
    {
        label: 'Fraud',
        value: ECardStatus.FRAUD
    },
    {
        label: 'Customer request',
        value: ECardStatus.CUSTOMER_REQUEST
    },
    {
        label: 'Closed',
        value: ECardStatus.CLOSED
    },
    {
        label: 'Legal closed',
        value: ECardStatus.LEGAL_CLOSED
    },
    {
        label: 'Frozen',
        value: ECardStatus.FREEZED
    }
];

export const kyc_error_localizations: { [key: string]: string } = {
    SPDR02: '(ShuftiPro) - Image of the face not found on the document.',
    SPDR03: '(ShuftiPro) - Image is altered or photoshopped.',
    SPDR04: '(ShuftiPro) - Copy of the image found on web.',
    SPDR05: '(ShuftiPro) - Document and Document Two does not belong to the same person.',
    SPDR06: '(ShuftiPro) - Document originality could not be verified.',
    SPDR07: "(ShuftiPro) - Name on the document doesn't match.",
    SPDR08: "(ShuftiPro) - DOB on the document doesn't match.",
    SPDR09: "(ShuftiPro) - Date on the document doesn't match.",
    SPDR10: "(ShuftiPro) - Issue date on the document doesn't match.",
    SPDR11: "(ShuftiPro) - Number on the document doesn't match.",
    SPDR12: '(ShuftiPro) - The issuing country of document is not supported, please upload a valid document.',
    SPDR13: "(ShuftiPro) - Document doesn't match the provided options.",
    SPDR14: '(ShuftiPro) - Age could not be verified.',
    SPDR15: "(ShuftiPro) - Face on the document doesn't match with camera image.",
    SPDR16: '(ShuftiPro) - The expiry date of the document does not match the record, please upload a document with valid expiry date.',
    SPDR17: '(ShuftiPro) - The document is expired, please upload a new document which is not expired.',
    SPDR18: '(ShuftiPro) - The uploaded image of the document is blur, please provide a clear photo of document.',
    SPDR19: '(ShuftiPro) - Face could not be detected in image, please upload image again with your face clearly visible.',
    SPDR21: '(ShuftiPro) - Proof and Additional Proof are of different documents.',
    SPDR36: '(ShuftiPro) - Both Documents do not belong to the same person.',
    SPDR42: '(ShuftiPro) - Front and backside images of the document did not match, please upload images of the same document.',
    SPDR43: '(ShuftiPro) - Camera is not accessible for verification.',
    SPDR44: '(ShuftiPro) - Gender could not be verified.',
    SPDR45: '(ShuftiPro) - Place of issue could not be verified.',
    SPDR47: '(ShuftiPro) - Document proof is a screenshot.',
    SPDR48: '(ShuftiPro) - Document proof is altered/edited.',
    SPDR49: '(ShuftiPro) - Document proof is paper based which is not accepted.',
    SPDR50: '(ShuftiPro) - Document proof is punched/broken.',
    SPDR51: '(ShuftiPro) - Document proof is from another screen.',
    SPDR52: '(ShuftiPro) - Hologram is missing on the document.',
    SPDR53: '(ShuftiPro) - Document proof is not fully displayed.',
    SPDR54: '(ShuftiPro) - Document is blur.',
    SPDR55: '(ShuftiPro) - Information on the document proof is not visible.',
    SPDR56: '(ShuftiPro) - Information on the document is edited.',
    SPDR57: '(ShuftiPro) - Information on the document is hidden.',
    SPDR63: '(ShuftiPro) - Front and backside images are not of the same document.',
    SPDR64: '(ShuftiPro) - Proof and additional proof does not belong to the same person.',
    SPDR66: '(ShuftiPro) - Both documents should belong to the same person.',
    SPDR67: '(ShuftiPro) - Document should be from the provided country.',
    SPDR68: '(ShuftiPro) - Issue date does not match with the provided one.',
    SPDR69: '(ShuftiPro) - Expiry date does not match with the provided one.',
    SPDR70: '(ShuftiPro) - Submitted document is expired.',
    SPDR71: '(ShuftiPro) - Issue date on the document is not clearly visible.',
    SPDR72: '(ShuftiPro) - Expiry date on the document is not clearly visible.',
    SPDR73: '(ShuftiPro) - Date of Birth on the document does not match with the provided one.',
    SPDR74: '(ShuftiPro) - Date of Birth on the document is not clearly visible.',
    SPDR75: '(ShuftiPro) - Name on the document does not match with the provided one.',
    SPDR76: '(ShuftiPro) - Name on the document is not clearly visible.',
    SPDR77: '(ShuftiPro) - Document number does not match with the provided one.',
    SPDR78: '(ShuftiPro) - Document number is not clearly visible.',
    SPDR79: '(ShuftiPro) - Original document number could not be authenticated.',
    SPDR86: '(ShuftiPro) - E-document data does not match with provided document proof.',
    SPDR87: '(ShuftiPro) - Face on the E-document does not match with selfie.',
    SPDR88: '(ShuftiPro) - Uploaded document is Black and White.',
    SPDR89: '(ShuftiPro) - Uploaded image of the document is edited or cropped.',
    SPDR90: '(ShuftiPro) - Uploaded image is found on the internet.',
    SPDR91: '(ShuftiPro) - Document is laminated.',
    SPDR92: '(ShuftiPro) - Document is scanned or colored copy.',
    SPDR93: '(ShuftiPro) - Document is paper-based or laminated.',
    SPDR94: '(ShuftiPro) - Uploaded document is a test card.',
    SPDR100: '(ShuftiPro) - Picture on the document is not updated.',
    SPDR103: '(ShuftiPro) - The uploaded document is not matched with the mentioned document type.',
    SPDR104: '(ShuftiPro) - Last name in the uploaded document doesn`t match the record.',
    SPDR105: '(ShuftiPro) - First name in the uploaded document doesn`t match the record.',
    SPDR220: '(ShuftiPro) - The document number on the document is invalid.',
    SPDR107: '(ShuftiPro) - Uploaded document is a test card.',
    SPDR111: '(ShuftiPro) - Uploaded document is expired.',
    SPDR113: '(ShuftiPro) - The issuing country of document is not supported.',
    SPDR114: '(ShuftiPro) - Gender on the document does not match with the provided gender.',
    SPDR116: '(ShuftiPro) - Gender is not mentioned in the uploaded document.',
    SPDR117: '(ShuftiPro) - Gender is unclear in the uploaded document.',
    SPDR118: '(ShuftiPro) - The Uploaded documents have different names.',
    SPDR120: '(ShuftiPro) - Information on the document is not readable.',
    SPDR121: '(ShuftiPro) - Entire document is not visible.',
    SPDR122: '(ShuftiPro) - Uploaded document of the image is blur.',
    SPDR124: '(ShuftiPro) - The uploaded document doesn`t match with the mentioned document type.',
    SPDR125: '(ShuftiPro) - Uploaded front side and backside are of different documents.',
    SPDR128: '(ShuftiPro) - Uploaded document is laminated.',
    SPDR129: '(ShuftiPro) - Document might be broken, damaged, or punched.',
    SPDR130: '(ShuftiPro) - Uploaded image of the document is a screenshot.',
    SPDR131: '(ShuftiPro) - Document is captured from another device.',
    SPDR133: '(ShuftiPro) - Document is paperbased or laminated.',
    SPDR134: '(ShuftiPro) - Uploaded image of the document is found on internet.',
    SPDR135: '(ShuftiPro) - Uploaded image is a test card.',
    SPDR136: '(ShuftiPro) - Uploaded document is black and white.',
    SPDR137: '(ShuftiPro) - Document is not found in the uploaded image.',
    SPDR140: '(ShuftiPro) - Middle name in the uploaded document doesn`t match the record.',
    SPDR142: '(ShuftiPro) - Issuing date of the document is not visible.',
    SPDR156: '(ShuftiPro) - Expire date is not found on the uploaded document.',
    SPDR159: '(ShuftiPro) - Expiry date of the document is not found.',
    SPDR165: '(ShuftiPro) - Name is not found on the uploaded document.',
    SPDR166: '(ShuftiPro) - Face image doesn`t match with the face on document.',
    SPDR169: '(ShuftiPro) - Issue date of the uploaded document doesn`t match the record.',
    SPDR171: '(ShuftiPro) - Expire date of the uploaded document is not visible.',
    SPDR174: '(ShuftiPro) - Name in the uploaded document is not visible.',
    SPDR179: '(ShuftiPro) - Name is not found on the document.',
    SPDR181: '(ShuftiPro) - Expire date of the uploaded document is not match.',
    SPDR221:
        '(ShuftiPro) - The gender mentioned on the document does not match with the provided information.',
    SPDR222: '(ShuftiPro) - The gender on the document is not clearly visible.',
    SPDR223: '(ShuftiPro) - The issue date on document is not present.',
    SPDR224: '(ShuftiPro) - The date of birth on document is not clearly visible.',
    SPDR234: '(ShuftiPro) - The date of birth on document is not present.',
    SPDR226:
        '(ShuftiPro) - The nationality on the document does not match the provided information.',
    SPDR227: '(ShuftiPro) - The nationality on the document is not clearly visible.',
    SPDR228: '(ShuftiPro) - The nationality on the document is not mentioned.',
    SPDR229: '(ShuftiPro) - The expiry date on document is not present.',
    SPDR232: '(ShuftiPro) - The name on document is not present.',
    SPDR235: '(ShuftiPro) - Face in provided document is edited.',
    SPDR236: '(ShuftiPro) - Font in provided document is edited.',
    SPDR237: '(ShuftiPro) - Background in provided document is edited.',
    SPDR238: '(ShuftiPro) - Text in provided document is edited.',
    SPDR239: '(ShuftiPro) - MRZ in provided document is edited.',
    SPDR240: '(ShuftiPro) - Provided document is edited via applying filters.',
    SPDR241: '(ShuftiPro) - The verification process was canceled by the user.',
    SPDR187: '(ShuftiPro) - Nationality could not be verified.',
    SPDR190: '(ShuftiPro) - The provided document is broken.',
    SPDR193: '(ShuftiPro) - The provided document is photocopy(color or black & white).',
    SPDR194: '(ShuftiPro) - The provided document is edited.',
    SPDR197: '(ShuftiPro) - The provided document is scanned.',
    SPDR200: '(ShuftiPro) - The provided document is punched.',
    SPDR201: '(ShuftiPro) - The provided document is cracked.',
    SPDR202: '(ShuftiPro) - The provided document is cropped.',
    SPDR203: '(ShuftiPro) - The provided document is handwritten.',
    SPDR204: '(ShuftiPro) - Document does not belong to GCC countries.',
    SPDR205: '(ShuftiPro) - Document type is not supported.',
    SPDR206: '(ShuftiPro) - Document type is not allowed.',
    SPDR207: '(ShuftiPro) - MRZ not detected on the document.',
    SPDR208: '(ShuftiPro) - Document is not visible or present in the proof.',
    SPDR209: '(ShuftiPro) - Student card is not acceptable.',
    SPDR210: '(ShuftiPro) - Dual cards detected.',
    SPDR211: '(ShuftiPro) - The uploaded document is not supported.',
    SPDR212: "(ShuftiPro) - First name on the document doesn't match.",
    SPDR213: '(ShuftiPro) - Middle name on the document doesn`t match.',
    SPDR214: '(ShuftiPro) - Last name on the document doesn`t match.',
    SPDR215: '(ShuftiPro) - The uploaded document is inverted or in mirror view.',
    SPDR216: '(ShuftiPro) - The uploaded document is broken with affected data.',
    SPDR217: '(ShuftiPro) - The same proof are not allowed for document and document two ID Card.',
    SPDR225: '(ShuftiPro) - The proof has been uploaded and not captured in real time.',
    SPDR271: '(ShuftiPro) - Frontside of the document is not displayed.',
    SPDR272: '(ShuftiPro) - Backside of the document is not displayed.',
    SPDR275: '(ShuftiPro) - Face could not be detected OR same side of the document is provided.',
    SPDR285: '(ShuftiPro) - Document proofs do not belong to the same person.',
    SPDR286: '(ShuftiPro) - Document Proof inconsistent creation and modification dates found.',
    SPDR01: '(ShuftiPro) - Face could not be verified.',
    SPDR37: '(ShuftiPro) - Face liveness detection failed.',
    SPDR40: '(ShuftiPro) - The answer to the question is incorrect.',
    SPDR58: '(ShuftiPro) - Face in the image is with wearing glasses.',
    SPDR59: '(ShuftiPro) - Face proof is taken from another screen.',
    SPDR60: '(ShuftiPro) - Face proof is taken from internet.',
    SPDR61: '(ShuftiPro) - More than one face in one image.',
    SPDR62: '(ShuftiPro) - Face proof is a screenshot.',
    SPDR96: '(ShuftiPro) - Face is not visible due to low lighting.',
    SPDR97: '(ShuftiPro) - Face image is blurry.',
    SPDR98: '(ShuftiPro) - Face image is cropped or edited.',
    SPDR99: '(ShuftiPro) - Face is not found on the document.',
    SPDR101: '(ShuftiPro) - Face is hidden on the document.',
    SPDR109: '(ShuftiPro) - Uploaded image is found on the internet.',
    SPDR144: '(ShuftiPro) - Hat or mask is found on the face.',
    SPDR168: '(ShuftiPro) - Face is not detected in the uploaded image.',
    SPDR218: '(ShuftiPro) - Face proof is edited using filters.',
    SPDR219: '(ShuftiPro) - The uploaded face picture is blur and not clearly visible.',
    SPDR230:
        '(ShuftiPro) - The uploaded face picture does not match the face photo on the provided document.',
    SPDR231: '(ShuftiPro) - The face picture on the provided document is not clearly visible.',
    SPDR233: '(ShuftiPro) - Face proof has a solid color in the background.',
    SPDR249: '(ShuftiPro) - Front or backside proof is not provided.',
    SPDR251: '(ShuftiPro) - Document front proof is not provided.',
    SPDR252: '(ShuftiPro) - Proof and additional proof are of same side of the document.',
    SPDR261: '(ShuftiPro) - MRZ Number on the document does not match.',
    SPDR262: '(ShuftiPro) - Data is hidden on the provided document.',
    SPDR263: '(ShuftiPro) - Uploaded image of the document is pixelated.',
    SPDR264: '(ShuftiPro) - Face image is not present on the document.',
    SPDR265: '(ShuftiPro) - Invalid cpf number provided.',
    SPDR268: '(ShuftiPro) - The provided image is corrupted.',
    SPDR274: '(ShuftiPro) - End user did not submit complete verification proofs or data.',
    SPDR276: '(ShuftiPro) - The user does not want to share camera or documents.',
    SPDR277: '(ShuftiPro) - Closed eyes are detected.',
    SPDR278: '(ShuftiPro) - Face proof is altered or photoshopped.',
    SPDR279: '(ShuftiPro) - Face proof is blur and not clear for verification.',
    SPDR280: '(ShuftiPro) - Eyes not visible and are covered with glasses.',
    SPDR281: '(ShuftiPro) - Multiple faces detected in face proof.',
    SPDR282: '(ShuftiPro) - Uploaded document is a test ID.',
    SPDR283: '(ShuftiPro) - Face could not be detected.',
    SPDR284: '(ShuftiPro) - The complete verification data was not provided by the user.',
    SPDR287: '(ShuftiPro) - Duplicate account is detected.',
    SPDR291: '(ShuftiPro) - Entire Face is not clear in the provided face proof.',
    SPDR34: '(ShuftiPro) - AML screening failed.',
    SPDR160: '(ShuftiPro) - AML screening failed. User found in Sanction lists.',
    SPDR161: '(ShuftiPro) - AML screening failed. User found in Warning lists.',
    SPDR162: '(ShuftiPro) - AML screening failed. User found in Fitness-Probity lists.',
    SPDR163: '(ShuftiPro) - AML screening failed. User found in PEP lists.',
    SPDR164: '(ShuftiPro) - AML screening failed. User found in Adverse-Media lists.',
    ERR001: "(Internal) - Something went wrong, we can't verify your identity",
    ERR002: "(Internal) - Something went wrong, we can't verify your identity",
    ERR003: "(Internal) - Something went wrong, we can't verify your identity",
    ERR004: "(Internal) - Something went wrong, we can't activate you profile. Please, contact our support team.",
    ERR005: "(Internal) - Something went wrong, we can't activate you profile. Please, contact our support team.",
    ERR006: "(Internal) - Something went wrong, we can't activate you profile. Please, contact our support team.",
    ER00001: '(Internal) - Something went wrong. Please contact support.',
    SP00001: '(ShuftiPro) - Something went wrong. Please try again later.',
    SP00002: '(ShuftiPro) - Something went wrong. Please contact support',
    KycScreeningError01:
        '(Processor) - Your verification is still in progress. We’ll notify you when it’s complete.',
    KycScreeningError02:
        '(Processor) - Your verification is still in progress. We’ll notify you when it’s complete.',
    KycScreeningError03: 'Something went wrong. Please try again later.',
    KycScreeningError04:
        '(Processor) - Address entered is invalid. Please use a suggested address from the ParameterList or visit Canada Post for more valid addresses: https://www.canadapost-postescanada.ca/ac/',
    KycScreeningError05:
        '(Processor) - Address entered is invalid. Please use a suggested address from the ParameterList or visit Canada Post for more valid addresses: https://www.canadapost-postescanada.ca/ac/',
    KycScreeningError06: '(Processor) - Something went wrong. Please contact support.',
    BNA0001: '(BNA) - Something went wrong. Please try again later.'
};
